import {
  Avatar,
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Show,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Logo from '@/components/atoms/Logo';
import { defaultBreakpoint } from '@/hooks/useBreakpoint';
import { useProfileStore } from '@/stores/RootStore';

function LogOut() {
  const { t } = useTranslation();
  const profileStore = useProfileStore();

  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const logOut = () => {
    localStorage.removeItem('long_life_token');

    window.location.assign(import.meta.env.VITE_URL as string);
  };

  const modalSize = useBreakpointValue(
    {
      base: 'full',
      [defaultBreakpoint]: '2xl',
    },
    defaultBreakpoint,
  );

  const avatarSrc = profileStore.profile.profilePic_url;

  return (
    <>
      <Button variant="text" colorScheme="primary" onClick={handleOpenModal}>
        {t('log_out')}
      </Button>

      <Modal
        isCentered={false}
        isOpen={isOpen}
        onClose={handleCloseModal}
        scrollBehavior="outside"
        size={modalSize}
      >
        <Show above={defaultBreakpoint}>
          <ModalOverlay
            bg="gray.overlay"
            backdropFilter="auto"
            backdropBlur="sm"
          />
        </Show>
        <ModalContent maxW="32rem">
          <ModalBody
            display="flex"
            flexDirection="column"
            justifyContent="center"
            py={{ base: 0, [defaultBreakpoint]: 8 }}
          >
            <Flex direction="column" alignItems="center" gridGap={4}>
              <Logo />
              <Text
                as="h2"
                variant="semibold"
                fontSize="3xl"
                textAlign="center"
              >
                {t('log_out_account')}
              </Text>
              <Flex>
                {avatarSrc && (
                  <Avatar
                    backgroundColor="gray.100"
                    size="lg"
                    alignSelf="center"
                    src={avatarSrc}
                    mr={3}
                  />
                )}
                <Box textAlign={avatarSrc ? 'left' : 'center'}>
                  <Text
                    as="h3"
                    variant="semibold"
                    fontSize="3xl"
                    wordBreak="break-all"
                  >
                    {`${profileStore.profile.firstName} ${profileStore.profile.lastName}`}
                  </Text>
                  <Text
                    color="blue.linkDark"
                    variant="semibold"
                    wordBreak="break-all"
                  >
                    {profileStore.profile.homeEmail}
                  </Text>
                </Box>
              </Flex>
              <Button
                variant="solidRounded"
                colorScheme="primaryBlue"
                onClick={() => logOut()}
              >
                {t('log_out')}
              </Button>
              <Button
                variant="text"
                colorScheme="primaryBlue"
                onClick={() => {
                  handleCloseModal();
                }}
              >
                {t('settings_stay_logged')}
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default observer(LogOut);
